export default __webpack_public_path__ + "static/media/miguel-lopes-17.4a705820.jpg";